<template>
  <div class="list row">
    <div class="col-md-12">
      <h4><font-awesome-icon icon="desktop" /> Calculation Board</h4>
      <div class=""></div>
      <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
        {{message}}
        <!--<table class="table">
        <tr>
            <th>maPv</th><th>paidAmount</th>
        </tr>
        <tr class="table" v-for="tpv in tpvs" :key="tpv.maPv">
            <td>{{ tpv.maPv }}</td><td>{{ tpv.paidAmount }}</td>
        </tr>
      </table>-->
      </div>
      <div v-else class="alert" style="color:green">
        <span v-show="processingInProgress" class="spinner-border spinner-border-sm"></span>
        <span v-if="calculationInProgressText">Calculation in progress!</span>
      </div>
    </div>
    <div class="col-md-12 hgap"></div>
    <!--<div class="col-md-4">
      <div class="card-container">
        <div class="card-body">
          <h5 class="card-title">Process Leg Calculation</h5>
          <p class="card-text">This is member process leg calculation. The process leg calculation must be done process PPV calculation.</p>
          <button class="btn btn-primary" @click="calculateProcessLegs"><font-awesome-icon icon="arrow-circle-right" /> Calculate Process Legs</button>
        </div>
      </div>
    </div>-->
    <div class="col-md-4">
      <div class="card-container2">
        <form name="form" @submit.prevent="calculateProcessPPV">
        <div class="card-body">
          <h5 class="card-title">Process PPV Calculation</h5>
          <p class="card-text">This is PPV calculation. The process PPV calculation must be done before level data calculation.</p>
          <select v-model="procPpvYear">
            <option disabled value="">Year</option>
            <option value="2026">2026</option>
          </select>
          &nbsp;&nbsp;
          <select v-model="procPpvMonth">
            <option disabled value="">Month</option>
            <option value="01">Jan</option>
            <option value="02">Feb</option>
            <option value="03">March</option>
            <option value="04">April</option>
            <option value="05">May</option>
            <option value="06">June</option>
            <option value="07">July</option>
            <option value="08">August</option>
            <option value="09">Sept</option>
            <option value="10">Oct</option>
            <option value="11">Nov</option>
            <option value="12">Dec</option>
          </select> 
          &nbsp;&nbsp;
          <button type="submit" class="btn btn-primary"><font-awesome-icon icon="arrow-circle-right" /> Calculate</button>
          <!--<button class="btn btn-primary" @click="calculateProcessPPV"><font-awesome-icon icon="arrow-circle-right" /> Calculate Process PPV</button>-->
        </div>
        </form>
      </div>
    </div>
    <div class="col-md-4"></div>
    <div class="col-md-4">
      <div class="card-container">
        <form name="form" @submit.prevent="calculateLevelData">
        <div class="card-body">
          <h5 class="card-title">Level Data Calculation</h5>
          <p class="card-text">This is members' level data calculation. The members' level data calculation must be done after process PPV calculation.</p>
          <select v-model="levDatYear">
            <option disabled value="">Year</option>
            <option value="2026">2026</option>
          </select>
          &nbsp;&nbsp;
          <select v-model="levDatMonth">
            <option disabled value="">Month</option>
            <option value="01">Jan</option>
            <option value="02">Feb</option>
            <option value="03">March</option>
            <option value="04">April</option>
            <option value="05">May</option>
            <option value="06">June</option>
            <option value="07">July</option>
            <option value="08">August</option>
            <option value="09">Sept</option>
            <option value="10">Oct</option>
            <option value="11">Nov</option>
            <option value="12">Dec</option>
          </select> 
          &nbsp;&nbsp;
          <button type="submit" class="btn btn-primary"><font-awesome-icon icon="arrow-circle-right" /> Calculate</button>
          <!--<button class="btn btn-primary" @click="calculateLevelData"><font-awesome-icon icon="arrow-circle-right" /> Calculate Level Data</button>-->
        </div>
        </form>
      </div>
    </div>   
    <div class="col-md-12 hgap"></div>
    <!--<div class="col-md-4">
      <div class="card-container2">
        <div class="card-body">
          <h5 class="card-title">Activation Data Calculation</h5>
          <p class="card-text">This is activation data calculation. The activation data calculation must be done after members level data calculation.</p>
         <button class="btn btn-primary" @click="calculateActivationData"><font-awesome-icon icon="arrow-circle-right" /> Calculate Activation Data</button>
        </div>
      </div>
    </div>-->
    <div class="col-md-4">
      <div class="card-container">
        <form name="form" @submit.prevent="calculatePreviousActivation">
        <div class="card-body">
          <h5 class="card-title">Previous Activation Calculation</h5>
          <p class="card-text">This is previous activation calculation. The previous activation calculation must be done after members level data calculation.</p>
          <select v-model="preActCalYear">
            <option disabled value="">Year</option>
            <option value="2026">2026</option>
          </select>
          &nbsp;&nbsp;
          <select v-model="preActCalMonth">
            <option disabled value="">Month</option>
            <option value="01">Jan</option>
            <option value="02">Feb</option>
            <option value="03">March</option>
            <option value="04">April</option>
            <option value="05">May</option>
            <option value="06">June</option>
            <option value="07">July</option>
            <option value="08">August</option>
            <option value="09">Sept</option>
            <option value="10">Oct</option>
            <option value="11">Nov</option>
            <option value="12">Dec</option>
          </select> 
          &nbsp;&nbsp;
          <button type="submit" class="btn btn-primary"><font-awesome-icon icon="arrow-circle-right" /> Calculate</button>
        </div>
        </form>
      </div>
    </div>
    <div class="col-md-4"></div>
    <div class="col-md-4">
      <div class="card-container">
        <form name="form" @submit.prevent="calculateActivation">
        <div class="card-body">
          <h5 class="card-title">Activation Calculation</h5>
          <p class="card-text">This is activation calculation for the relevant month. The activation calculation must be done after activation data calculation.</p>
          <select v-model="actCalYear">
            <option disabled value="">Year</option>
            <option value="2026">2026</option>
          </select>
          &nbsp;&nbsp;
          <select v-model="actCalMonth">
            <option disabled value="">Month</option>
            <option value="01">Jan</option>
            <option value="02">Feb</option>
            <option value="03">March</option>
            <option value="04">April</option>
            <option value="05">May</option>
            <option value="06">June</option>
            <option value="07">July</option>
            <option value="08">August</option>
            <option value="09">Sept</option>
            <option value="10">Oct</option>
            <option value="11">Nov</option>
            <option value="12">Dec</option>
          </select> 
          &nbsp;&nbsp;
          <button type="submit" class="btn btn-primary"><font-awesome-icon icon="arrow-circle-right" /> Calculate</button>
        </div>
        </form>
      </div>
    </div>
    <div class="col-md-12 hgap"></div>
    <div class="col-md-4">
      <div class="card-container">
        <form name="form" @submit.prevent="calculateActivationPayment">
        <div class="card-body">
          <h5 class="card-title">Activation Payment Calculation</h5>
          <p class="card-text">This is activation payment calculation for the relevant month. The activation payment calculation must be done after activation calculation.</p>
          <select v-model="actCalPayYear">
            <option disabled value="">Year</option>
            <option value="2026">2026</option>
          </select>
          &nbsp;&nbsp;
          <select v-model="actCalPayMonth">
            <option disabled value="">Month</option>
            <option value="01">Jan</option>
            <option value="02">Feb</option>
            <option value="03">March</option>
            <option value="04">April</option>
            <option value="05">May</option>
            <option value="06">June</option>
            <option value="07">July</option>
            <option value="08">August</option>
            <option value="09">Sept</option>
            <option value="10">Oct</option>
            <option value="11">Nov</option>
            <option value="12">Dec</option>
          </select> 
          &nbsp;&nbsp;
          <button type="submit" class="btn btn-primary"><font-awesome-icon icon="arrow-circle-right" /> Calculate</button>
        </div>
        </form>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card-container2">
        <div class="card-body">
          <h5 class="card-title">Awards' Data Calculation</h5>
          <p class="card-text">This is awards' data calculation. The awards' data calculation must be done after activation payment calculation.</p>
         <button class="btn btn-primary" @click="calculateAwardsData"><font-awesome-icon icon="arrow-circle-right" /> Calculate Awards Data</button>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card-container">
        <form name="form" @submit.prevent="calculateMembersBonus">
        <div class="card-body">
          <h5 class="card-title">Members' Bonus Calculation</h5>
          <p class="card-text">This is members' bonus calculation. The members' bonus calculation must be done after awards' data calculation and it is the last to run.</p>
          <select v-model="memBonCalYear">
            <option disabled value="">Year</option>
            <option value="2026">2026</option>
          </select>
          &nbsp;&nbsp;
          <select v-model="memBonCalMonth">
            <option disabled value="">Month</option>
            <option value="01">Jan</option>
            <option value="02">Feb</option>
            <option value="03">March</option>
            <option value="04">April</option>
            <option value="05">May</option>
            <option value="06">June</option>
            <option value="07">July</option>
            <option value="08">August</option>
            <option value="09">Sept</option>
            <option value="10">Oct</option>
            <option value="11">Nov</option>
            <option value="12">Dec</option>
          </select> 
          &nbsp;&nbsp;
          <button type="submit" class="btn btn-primary"><font-awesome-icon icon="arrow-circle-right" /> Calculate</button>
        </div>
        </form>
      </div>
    </div>
    <div class="col-md-12 hgap"></div>
    
  </div>
</template>

<script>
//import ProcessLegService from "../services/process-leg.service";
//import ProcessLeg from '../models/processleg';
import MemberService from "../services/member.service";
import SaleService from "../services/sale.service";
import ProcessPpvService from "../services/process-ppv.service";
//import ProcessPpv from '../models/process-ppv';
import MonthlyActivationPvService from "../services/monthly-activation-pv.service";
//import MonthlyActivationPv from '../models/monthlyactivationpv';
//import MemberAwardService from "../services/member-award.service";
//import MemberAward from '../models/memberaward';
import MonthlyBonusService from "../services/monthly-bonus.service";
//import MonthlyBonus from '../models/monthlybonus';
//import MonthlyMembersBonusService from "../services/monthly-members-bonus.service";
//import MonthlyMembersBonus from '../models/monthlymembersbonus';
//import CalculationControlService from "../services/calculation-control.service";

export default {
  name: "calculation-board",
  data() {
    return {
      processingInProgress: false,
      calculationInProgressText: false,
      message: '',
      successful: false,
      //processLeg: new ProcessLeg(0, 0, 0, 0),
      /*processPpv: {
        id: null,
        memberId: 0,
        totalPpv: 0,
        totalNdc: 0,
        monthlyPpv: 0,
        monthlyNdc: 0,
        networkLevel: 0,
        userLevel: 0,
        month: '',
        year: ''
      },*/
      //memberAward: new MemberAward('', 0, 0),
      processLegs: [],
      tpvs: [],
      frontlineCount: 0,
      networkLevel: 0,
      userLevel: 0,
      descendants: [],
      descendant2s: [],
      members: [],
      notPaidMonthlyActivationPvs: [],
      notPaidByDateAndPaidStatusMonthlyActivationPvs: [],
      networkMembers: [],
      numberOfUplineMembers: 0,
      numberOfUplineAndValueMembers: 0,
      firstDownlines: [],
      procPpvYear: '',
      procPpvMonth: '',
      levDatYear: '',
      levDatMonth: '',
      preActCalYear: '',
      preActCalMonth: '',
      actCalYear: '',
      actCalMonth: '',
      actCalPayYear: '',
      actCalPayMonth: '',
      memBonCalYear: '',
      memBonCalMonth: ''
    };
  },
  methods: {
    calculateProcessPPV() {
      this.successful = false;
      this.processingInProgress = true;
      this.calculationInProgressText = true;
      //let date = new Date();
      //let year = date.getFullYear();
      //let month = date.getMonth() + 1;
      //let year = '2020';
      //let month = '11';
      let year = this.procPpvYear;
      let month = this.procPpvMonth;
      let period = month +'/'+ year;
      ProcessPpvService.getProcessPPVCountByMonthAndYear(month, year).then(
        response => {
          let processPPVMonthAndYearCount = response.data;
          if(processPPVMonthAndYearCount > 0){
            this.successful = false;
            this.processingInProgress = false;
            this.calculationInProgressText = false;
            this.message = 'Sorry, process PPV calculation has be done for the period: '+period;
          }
          else { 
            ProcessPpvService.calculateProcessPPV(month, year)
              .then(response => {
                console.log(response.data);
                this.successful = true;
                this.processingInProgress = false;
                this.calculationInProgressText = false;
                //this.message = 'Process PPV calculated successfully!';
                this.message = response.data.message;
                //let responseMessage = response.data.message;

                /*var ccData = {
                  month: month,
                  year: year,
                  processPpvCalDone: true,
                  levelDataCalDone: false,
                  activationDataCalDone: false,
                  monthlyActivationCalDone: false,
                  activationPaymentCalDone: false,
                  awardsDataCalDone: false,
                  membersBonusCalDone: false
                };

                CalculationControlService.create(ccData)
                  .then(response => {
                    console.log(response.data);
                    this.successful = true;
                    this.processingInProgress = false;
                    this.calculationInProgressText = false;
                    //this.message = 'Process PPV calculated successfully!';
                    this.message = responseMessage;
                  },
                  error => {
                  this.message = (error.response && error.response.data) || error.message || error.toString();
                  })
                  .catch(e => {
                    //console.log(e);
                    this.message = 'Error: '+e.message;
                  });*/
              },
              error => {
                this.successful = false;
                this.processingInProgress = false;
                this.calculationInProgressText = false;
                this.message = (error.response && error.response.data) || error.message || error.toString();
              })
              .catch(e => {
                //console.log(e);
                this.successful = false;
                this.processingInProgress = false;
                this.calculationInProgressText = false;
                this.message = 'Error: '+e.message;
              });
            //ProcessPpvService.calculateProcessPPV(month, year)
          }  
        },
        error => {
          this.successful = false;
          this.processingInProgress = false;
          this.calculationInProgressText = false;
          this.message = (error.response && error.response.data) || error.message || error.toString();
        })
        .catch(e => {
          //console.log(e);
          this.successful = false;
          this.processingInProgress = false;
          this.calculationInProgressText = false;
          this.message = 'Error: '+e.message;
        });  
      //End of ProcessPpvService.getProcessPPVMonthAndYearCount(month, year)
    
    },

    calculateLevelData() {
      this.successful = false;
      this.processingInProgress = true;
      this.calculationInProgressText = true;
      //let date = new Date();
      //let year = date.getFullYear();
      //let month = date.getMonth() + 1;
      //let year = '2020';
      //let month = '11';
      let year = this.levDatYear;
      let month = this.levDatMonth;
      //let period = month +'/'+ year;
      /*CalculationControlService.getCalculationControl().then(
        response => {
          let calculationControl = response.data;
          if(calculationControl.processPpvCalDone != true){
            this.successful = false;
            this.processingInProgress = false;
            this.calculationInProgressText = false;
            this.message = 'Error, please follow the order of calculation!';
          }
          else {*/
            ProcessPpvService.calculateLevelData(month, year)
              .then(response => {
                console.log(response.data);
                this.successful = true;
                this.processingInProgress = false;
                this.calculationInProgressText = false;
                //this.message = 'Level calculation completed successfully!';
                this.message = response.data.message;
                //let responseMessage = response.data.message;
                
                /*calculationControl.levelDataCalDone = true;
                CalculationControlService.update(calculationControl.id, calculationControl)
                  .then(response => {
                    console.log(response.data);

                    this.successful = true;
                    this.processingInProgress = false;
                    this.calculationInProgressText = false;
                    //this.message = 'Level calculation completed successfully!';
                    this.message = responseMessage;
                  },
                  error => {
                    this.message = (error.response && error.response.data) || error.message || error.toString();
                  })
                  .catch(e => {
                    //console.log(e);
                    this.message = 'Error: '+e.message;
                  });*/
              },
              error => {
                this.successful = false;
                this.processingInProgress = false;
                this.calculationInProgressText = false;
                this.message = (error.response && error.response.data) || error.message || error.toString();
              })
              .catch(e => {
              //console.log(e);
                this.successful = false;
                this.processingInProgress = false;
                this.calculationInProgressText = false;
                this.message = 'Error: '+e.message;
              });
            //End of ProcessPpvService.calculateLevelData(month, year)
          //}
				//});
            
    },

    calculateActivationData() {
      this.successful = false;
      this.processingInProgress = true;
      this.calculationInProgressText = true;
      let monthlyActivationPvsCountByPaidStatus = 0;      
      MonthlyActivationPvService.getMonthlyActivationPvsCountByPaidStatus().then(
        response => {
          monthlyActivationPvsCountByPaidStatus = response.data;
          if(monthlyActivationPvsCountByPaidStatus <= 0){
            this.successful = false;
            this.processingInProgress = false;
            this.calculationInProgressText = false;
            this.message = 'There are no activation data to calculate!'; 
          }
          else { 
            /*CalculationControlService.getCalculationControl().then(
              response => {
                let calculationControl = response.data;
                if(calculationControl.processPpvCalDone != true  && calculationControl.levelDataCalDone != true){
                  this.successful = false;
                  this.processingInProgress = false;
                  this.calculationInProgressText = false;
                  this.message = 'Error, please follow the order of calculation!';
                }
                else {*/ 
                  MonthlyActivationPvService.calculateActivationData()
                    .then(response => {
                      console.log(response.data);
                      this.successful = true;
                      this.processingInProgress = false;
                      this.calculationInProgressText = false;
                      //this.message = 'Activation data calculation completed successfully!';
                      this.message = response.data.message;
                      //let responseMessage = response.data.message;

                      /*calculationControl.activationDataCalDone = true;
                      CalculationControlService.update(calculationControl.id, calculationControl)
                        .then(response => {
                          console.log(response.data);

                          this.successful = true;
                          this.processingInProgress = false;
                          this.calculationInProgressText = false;
                          //this.message = 'Activation data calculation completed successfully!';
                          this.message = responseMessage;
                        },
                        error => {
                          this.message = (error.response && error.response.data) || error.message || error.toString();
                        })
                        .catch(e => {
                          //console.log(e);
                          this.message = 'Error: '+e.message;
                        });*/
                    },
                    error => {
                      this.successful = false;
                      this.processingInProgress = false;
                      this.calculationInProgressText = false;
                      this.message = (error.response && error.response.data) || error.message || error.toString();
                    })
                    .catch(e => {
                      //console.log(e);
                      this.successful = false;
                      this.processingInProgress = false;
                      this.calculationInProgressText = false;
                      this.message = 'Error: '+e.message;
                    });
                  //End of MonthlyActivationPvService.calculateActivationData()
                //}
              //});
            
          }  
        },
        error => {
          this.successful = false;
          this.processingInProgress = false;
          this.calculationInProgressText = false;
          this.message = (error.response && error.response.data) || error.message || error.toString();
        })
        .catch(e => {
          //console.log(e);
          this.successful = false;
          this.processingInProgress = false;
          this.calculationInProgressText = false;
          this.message = 'Error: '+e.message;
        });  
      //End of MonthlyActivationPvService.getMonthlyActivationPvsCountByPaidStatus()      
    },

    calculatePreviousActivation() {
      this.successful = false;
      this.processingInProgress = true;
      this.calculationInProgressText = true;
      let monthlyActivationPvsCountByPaidStatus = 0;      
      MonthlyActivationPvService.getMonthlyActivationPvsCountByPaidStatus().then(
        response => {
          monthlyActivationPvsCountByPaidStatus = response.data;
          if(monthlyActivationPvsCountByPaidStatus <= 0){
            this.successful = false;
            this.processingInProgress = false;
            this.calculationInProgressText = false;
            this.message = 'There are no previous activation to calculate!'; 
          }
          else { 
            /*CalculationControlService.getCalculationControl().then(
              response => {
                let calculationControl = response.data;
                if(calculationControl.processPpvCalDone != true  && calculationControl.levelDataCalDone != true){
                  this.successful = false;
                  this.processingInProgress = false;
                  this.calculationInProgressText = false;
                  this.message = 'Error, please follow the order of calculation!';
                }
                else {*/ 
                  MonthlyActivationPvService.calculatePreviousActivation(this.preActCalMonth, this.preActCalYear)
                    .then(response => {
                      console.log(response.data);
                      this.successful = true;
                      this.processingInProgress = false;
                      this.calculationInProgressText = false;
                      //this.message = 'Activation data calculation completed successfully!';
                      this.message = response.data.message;
                      //let responseMessage = response.data.message;

                      /*calculationControl.activationDataCalDone = true;
                      CalculationControlService.update(calculationControl.id, calculationControl)
                        .then(response => {
                          console.log(response.data);

                          this.successful = true;
                          this.processingInProgress = false;
                          this.calculationInProgressText = false;
                          //this.message = 'Activation data calculation completed successfully!';
                          this.message = responseMessage;
                        },
                        error => {
                          this.message = (error.response && error.response.data) || error.message || error.toString();
                        })
                        .catch(e => {
                          //console.log(e);
                          this.message = 'Error: '+e.message;
                        });*/
                    },
                    error => {
                      this.successful = false;
                      this.processingInProgress = false;
                      this.calculationInProgressText = false;
                      this.message = (error.response && error.response.data) || error.message || error.toString();
                    })
                    .catch(e => {
                      //console.log(e);
                      this.successful = false;
                      this.processingInProgress = false;
                      this.calculationInProgressText = false;
                      this.message = 'Error: '+e.message;
                    });
                  //End of MonthlyActivationPvService.calculateActivationData()
                //}
              //});
            
          }  
        },
        error => {
          this.successful = false;
          this.processingInProgress = false;
          this.calculationInProgressText = false;
          this.message = (error.response && error.response.data) || error.message || error.toString();
        })
        .catch(e => {
          //console.log(e);
          this.successful = false;
          this.processingInProgress = false;
          this.calculationInProgressText = false;
          this.message = 'Error: '+e.message;
        });  
      //End of MonthlyActivationPvService.getMonthlyActivationPvsCountByPaidStatus()      
    },

    calculateActivation() {
      this.successful = false;
      this.processingInProgress = true;
      this.calculationInProgressText = true;

      let mdate = this.actCalYear +'-'+ this.actCalMonth;
      let period = this.actCalMonth +'/'+ this.actCalYear;
      //let year = '2020';
      //let month = '11';
      //let mdate = year +'-'+ month;
      //let period = month +'/'+ year;

      let monthlyActivationPvsCountByDate = 0;
                 
      MonthlyActivationPvService.getMonthlyActivationPvsCountByDate(mdate).then(
        response => {
          monthlyActivationPvsCountByDate = response.data;
          if(monthlyActivationPvsCountByDate > 0){
            this.successful = false;
            this.processingInProgress = false;
            this.calculationInProgressText = false;
            this.message = 'Sorry, monthly activation calculation has be done for the period: '+period;
          }
          else { 
            /*CalculationControlService.getCalculationControl().then(
              response => {
                let calculationControl = response.data;
                if(calculationControl.processPpvCalDone != true  && calculationControl.levelDataCalDone != true && calculationControl.activationDataCalDone != true){
                  this.successful = false;
                  this.processingInProgress = false;
                  this.calculationInProgressText = false;
                  this.message = 'Error, please follow the order of calculation!';
                }
                else {*/
                  MonthlyActivationPvService.calculateMonthlyActivation(this.actCalMonth, this.actCalYear)
                    .then(response => {
                      console.log(response.data);
                      this.successful = true;
                      this.processingInProgress = false;
                      this.calculationInProgressText = false;
                      //this.message = 'Monthly activation process completed successfully!';
                      this.message = response.data.message;
                      //let responseMessage = response.data.message;

                      /*calculationControl.monthlyActivationCalDone = true;
                      CalculationControlService.update(calculationControl.id, calculationControl)
                        .then(response => {
                          console.log(response.data);

                          this.successful = true;
                          this.processingInProgress = false;
                          this.calculationInProgressText = false;
                          //this.message = 'Monthly activation process completed successfully!';
                          this.message = responseMessage;

                        },
                        error => {
                          this.message = (error.response && error.response.data) || error.message || error.toString();
                        })
                        .catch(e => {
                          //console.log(e);
                          this.message = 'Error: '+e.message;
                        });*/

                    },
                    error => {
                      this.successful = false;
                      this.processingInProgress = false;
                      this.calculationInProgressText = false;
                      this.message = (error.response && error.response.data) || error.message || error.toString();
                    })
                    .catch(e => {
                      //console.log(e);
                      this.successful = false;
                      this.processingInProgress = false;
                      this.calculationInProgressText = false;
                      this.message = 'Error: '+e.message;
                    });
                  //End of MonthlyActivationPvService.calculateMonthlyActivation(month, year)
                //}
              //});
            
          }  
        },
        error => {
          this.successful = false;
          this.processingInProgress = false;
          this.calculationInProgressText = false;
          this.message = (error.response && error.response.data) || error.message || error.toString();
        })
        .catch(e => {
          //console.log(e);
          this.successful = false;
          this.processingInProgress = false;
          this.calculationInProgressText = false;
          this.message = 'Error: '+e.message;
        });  
      //End of MonthlyActivationPvService.getMonthlyActivationPvsCountByDate(mdate)      
    }, 

    calculateActivationPayment() {
      this.successful = false;
      this.processingInProgress = true;
      this.calculationInProgressText = true;
      //let mdate = this.actCalPayYear +'-'+ this.actCalPayMonth;
      //let year = '2017';
      //let month = '11';
      //let mdate = year +'-'+ month;
      /*CalculationControlService.getCalculationControl().then(
        response => {
          let calculationControl = response.data;
          if(calculationControl.processPpvCalDone != true  && calculationControl.levelDataCalDone != true && calculationControl.activationDataCalDone != true && calculationControl.monthlyActivationCalDone != true){
            this.successful = false;
            this.processingInProgress = false;
            this.calculationInProgressText = false;
            this.message = 'Error, please follow the order of calculation!';
          }
          else {*/
            MonthlyActivationPvService.calculateActivationPayment(this.actCalPayMonth, this.actCalPayYear)
              .then(response => {
                console.log(response.data);
                this.successful = true;
                this.processingInProgress = false;
                this.calculationInProgressText = false;
                //this.message = 'Activation payment calculation completed successfully!';
                this.message = response.data.message;
                //let responseMessage = response.data.message;

                /*calculationControl.activationPaymentCalDone = true;
                CalculationControlService.update(calculationControl.id, calculationControl)
                  .then(response => {
                    console.log(response.data);

                    this.successful = true;
                    this.processingInProgress = false;
                    this.calculationInProgressText = false;
                    //this.message = 'Activation payment calculation completed successfully!';
                    this.message = responseMessage;
                  },
                  error => {
                    this.message = (error.response && error.response.data) || error.message || error.toString();
                  })
                  .catch(e => {
                    //console.log(e);
                    this.message = 'Error: '+e.message;
                  });*/
              },
              error => {
                this.successful = false;
                this.processingInProgress = false;
                this.calculationInProgressText = false;
                this.message = (error.response && error.response.data) || error.message || error.toString();
              })
              .catch(e => {
                //console.log(e);
                this.successful = false;
                this.processingInProgress = false;
                this.calculationInProgressText = false;
                this.message = 'Error: '+e.message;
              });
            //End of MonthlyActivationPvService.calculateActivationPayment(month, year)
          //}
        //});
      

    },

    calculateAwardsData() {
      this.successful = false;
      this.processingInProgress = true;
      this.calculationInProgressText = true;
      /*CalculationControlService.getCalculationControl().then(
        response => {
          let calculationControl = response.data;
          if(calculationControl.processPpvCalDone != true  && calculationControl.levelDataCalDone != true && calculationControl.activationDataCalDone != true && calculationControl.monthlyActivationCalDone != true && calculationControl.activationPaymentCalDone != true){
            this.successful = false;
            this.processingInProgress = false;
            this.calculationInProgressText = false;
            this.message = 'Error, please follow the order of calculation!';
          }
          else {*/ 
            MemberService.calculateAwardsData()
              .then(response => {
                console.log(response.data);
                this.successful = true;
                this.processingInProgress = false;
                this.calculationInProgressText = false;
                //this.message = 'Members awards calculated successfully!';
                this.message = response.data.message;
                //let responseMessage = response.data.message;

                /*calculationControl.awardsDataCalDone = true;
                CalculationControlService.update(calculationControl.id, calculationControl)
                  .then(response => {
                    console.log(response.data);

                    this.successful = true;
                    this.processingInProgress = false;
                    this.calculationInProgressText = false;
                    //this.message = 'Members awards calculated successfully!';
                    this.message = responseMessage;
                  },
                  error => {
                    this.message = (error.response && error.response.data) || error.message || error.toString();
                  })
                  .catch(e => {
                    //console.log(e);
                    this.message = 'Error: '+e.message;
                  });*/
              },
              error => {
                this.successful = false;
                this.processingInProgress = false;
                this.calculationInProgressText = false;
                this.message = (error.response && error.response.data) || error.message || error.toString();
              })
              .catch(e => {
                //console.log(e);
                this.successful = false;
                this.processingInProgress = false;
                this.calculationInProgressText = false;
                this.message = 'Error: '+e.message;
              });
            //End of MemberService.calculateAwardsData()
          //}
        //});
      

    },

    /*Old calculationMembersBonus method*/
    calculateMembersBonus() {
      this.successful = false;
      this.processingInProgress = true;
      this.calculationInProgressText = true;
      /*let mdate = this.memBonCalYear +'-'+ this.memBonCalMonth;*/
      let period = this.memBonCalMonth +'/'+ this.memBonCalYear;
      let year = this.memBonCalYear;
      let month = this.memBonCalMonth; 
      /*CalculationControlService.getCalculationControl().then(
        response => {
          let calculationControl = response.data;
          if(calculationControl.processPpvCalDone != true  && calculationControl.levelDataCalDone != true && calculationControl.activationDataCalDone != true && calculationControl.monthlyActivationCalDone != true && calculationControl.activationPaymentCalDone != true && calculationControl.awardsDataCalDone != true){
            this.successful = false;
            this.processingInProgress = false;
            this.calculationInProgressText = false;
            this.message = 'Error, please follow the order of calculation!';
          }
          else {*/ 
            MonthlyBonusService.getMonthlyBonusCount(month, year).then(
              response => {
                let monthlyBonusCount = response.data;
                if(monthlyBonusCount > 0){
                  this.successful = false;
                  this.processingInProgress = false;
                  this.calculationInProgressText = false;
                  this.message = 'Sorry, members bonus calculation has be done for the period: '+period;
                }
                else { 
                  SaleService.calculateMembersBonus(month, year)
                    .then(response => {
                      console.log(response.data);
                      this.successful = true;
                      this.processingInProgress = false;
                      this.calculationInProgressText = false;
                      this.message = 'Members bonus calculated successfully!';
                       
                      /*calculationControl.membersBonusCalDone = true;
                      CalculationControlService.update(calculationControl.id, calculationControl)
                        .then(response => {
                          console.log(response.data);

                          this.successful = true;
                          this.processingInProgress = false;
                          this.calculationInProgressText = false;
                          this.message = 'Members bonus calculated successfully!';
                        },
                        error => {
                          this.message = (error.response && error.response.data) || error.message || error.toString();
                        })
                        .catch(e => {
                          //console.log(e);
                          this.message = 'Error: '+e.message;
                        });*/
                    },
                    error => {
                      this.successful = false;
                      this.processingInProgress = false;
                      this.calculationInProgressText = false;
                      this.message = (error.response && error.response.data) || error.message || error.toString();
                    })
                    .catch(e => {
                      console.log(e);
                      this.successful = false;
                      this.processingInProgress = false;
                      this.calculationInProgressText = false;
                      this.message = 'Error: '+e.message;
                    });
                  //End of SaleService.calculateMembersBonus(month, year)
                }  
              },
              error => {
                this.successful = false;
                this.processingInProgress = false;
                this.calculationInProgressText = false;
                this.message = (error.response && error.response.data) || error.message || error.toString();
              })
              .catch(e => {
                console.log(e);
                this.successful = false;
                this.processingInProgress = false;
                this.calculationInProgressText = false;
                this.message = 'Error: '+e.message;
              });  
            //End of MonthlyBonusService.getMonthlyBonusCount(month, year)
          /*}
        });*/     
            
    },
    
    //New stuff that does not work, starts here
    /*calculateMembersBonus() {
      this.successful = false;
      this.processingInProgress = true;
      this.calculationInProgressText = true;
      let year = this.memBonCalYear;
      let month = this.memBonCalMonth; 
      this.getCurrentBonusCount(month, year, this.calculateBonuses);      
    }, 

    getCurrentBonusCount(month, year, callback){
      MonthlyBonusService.getMonthlyBonusCount(month, year).then(
        response => {
          let monthlyBonusCount = response.data;
          if(monthlyBonusCount > 0){
            this.successful = false;
            this.processingInProgress = false;
            this.calculationInProgressText = false;
            let period = this.month +'/'+ year;
            this.message = 'Sorry, members bonus calculation has be done for the period: '+period;
          }
          else{
            this.cacllback(month, year);
          }
        },
        error => {
          this.successful = false;
          this.processingInProgress = false;
          this.calculationInProgressText = false;
          this.message = (error.response && error.response.data) || error.message || error.toString();
        })
        .catch(e => {
          console.log(e);
          this.successful = false;
          this.processingInProgress = false;
          this.calculationInProgressText = false;
          this.message = 'Error: '+e.message;
        });

    },

    calculateBonuses(month, year) {
      SaleService.calculateMembersBonus(month, year)
        .then(response => {
          console.log(response.data);
          this.successful = true;
          this.processingInProgress = false;
          this.calculationInProgressText = false;
          this.message = 'Members bonus calculated successfully!';
        },
        error => {
          this.successful = false;
          this.processingInProgress = false;
          this.calculationInProgressText = false;
          this.message = (error.response && error.response.data) || error.message || error.toString();
        })
        .catch(e => {
          //console.log(e);
          this.successful = false;
          this.processingInProgress = false;
          this.calculationInProgressText = false;
          this.message = 'Error: '+e.message;
        });
                  
    },*/ ////New stuff that does not work, ends here

    membersList() {
      this.$router.push('/members');
    }

  },
  mounted() {
    //this.getSponsorDownlinesNo(this.$route.params.id);
  }
};
</script>

<style>
.list {
  text-align: left;
  max-width: 100%;
  margin: auto;
  margin-top: 3.2em;
}
.paginate{
  margin-top: 1.7em;
}
.hgap{
  clear: both;
  margin-top: 0.1em;
}

.card-container.card {
  max-width: 450px !important;
  padding: 0 0;
}

.card-container2.card {
  float: right;
  max-width: 450px !important;
  padding: 0 0;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
}
</style>